<template>
    <v-app class="vuetify-layout">
        <div class="login" v-on:keyup.enter="submit" style="background-color: darkgray;">
            <div class="container">
                <div class="logo-container">
                    <logo class="ml-1" :logo="$page.props.organization.settings.main_logo_path"></logo>
                </div>

                <div class="form-wrap">
                    <v-alert v-if="form.hasErrors" color="red" type="error">
                        <ul>
                            <li v-for="error in form.errors" :key="error">{{ error }}</li>
                        </ul>
                    </v-alert>

                    <form method="POST">
                        <p class="info-text">{{ $page.props.lang.forgotPassword || 'Forgot your password? No problem. Just let us know your email address and we will email you a password reset link that will allow you to choose a new one.' }}</p>
                        <label>{{ ($page.props.lang && $page.props.lang.email) || 'Email' }}</label>
                        <v-text-field v-model="form.email" outlined solo flat dense></v-text-field>
                        <div class="actions">
                            <v-btn color="primary" :loading="loading" @click="submit" class="button">{{ ($page.props.lang &&
                                $page.props.lang.emailPassword) || "Email password reset link" }}</v-btn>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </v-app>
</template>

<script>
import Logo from '@/js/Components/Logo'
export default {
    components: {
        Logo
    },
    metaInfo() {
        return {
            title: this.$page.props.lang.forgotPasswordTitle || "Forgot your password"
        }
    },
    data() {
        return {
            form: this.$inertia.form({
                email: null,
                password: null,
                remember: false,
            }),

            loading: false
        }
    },
    methods: {
        submit() {
            this.loading = true;
            this.form.post('/forgot-password', {
                preserveScroll: true,
                onFinish: visit => {
                    this.loading = false;
                }
            });


        }
    }
}
</script>
